// Reads the upload check response, which carries the legacy checker's flags and, in live mode, the V2 result.

export function isImageRulesResultBlocked(result) {
    return result?.imageCheckerV2?.outcome === 'block'
}

export function hasImageRulesViolations(result) {
    if (!result) {
        return false
    }

    return (
        Object.values(result).some((value) => value === true) ||
        ['warn', 'block'].includes(result.imageCheckerV2?.outcome)
    )
}
